// import axios from 'axios'
import { post, put, get } from '@/api/api'

export const actions = {
  fetchSites({ commit }) {
    // const { pageNumber = 0, pageSize = state.pagination.size } = params
    return get(`/canal/site`)
      .then(({ data }) => {
        commit('addSites', data)
      })
  },
  async fetchSitePage({ commit }, params = {}) {
    const { pageNumber = 0, pageSize = 10, sort = '', name = '', ville = '', code = '', after = '', before = '' } = params;
    const queryParams = new URLSearchParams({
      pageNumber,
      pageSize,
      sort,
      ...(name && { name }),
      ...(ville && { ville }),
      ...(code && { code }),
      ...(after && { after }),
      ...(before && { before }),
    }).toString();

    let { data } = await get(`/canal/site/page?${queryParams}`);
    commit("addSitePage", data)
    return data;
  },
  createSite({ commit }, site) {
    return post('/canal/site', site)
      .then(({ data }) => {
        commit('addSite', data)
      })
  },
  updateSite({ commit }, site) {
    return put(`/canal/site/${site.id}`, site)
      .then(({ data }) => {
        commit('replaceSite', data)
      })
  },
  createOrUpdateSite({ dispatch }, site) {
    if (site.id !== undefined) {
      return dispatch('updateSite', site)
    } else {
      return dispatch('createSite', site)
    }
  },
  selectSite({ commit }, site) {
    commit('setSite', site)
  },
  deleteSite({ commit }, site) {
    return remove(`/canal/site/${site.id}`)
      .then(({ data }) => { })
  },
}
